import {
  PROP_REQUEST_ID,
  PROP_TYPE,
  PROP_START,
  PROP_END,
  PROP_CODE,
  PROP_ERRORS,
  PROP_STATUS,
  PROP_RESPONSE,
  PROP_QUERY_PARAMS,
  PROP_MODEL_ID,
  PROP_URL,
  IN_PROGRESS,
} from './constants'

import moment from 'moment'

export default ({messageId, method, queryParams, url}) => ({
  [PROP_REQUEST_ID]: messageId,
  [PROP_TYPE]: method,
  [PROP_START]: moment().unix(),
  [PROP_END]: null,
  [PROP_CODE]: null,
  [PROP_ERRORS]: null,
  [PROP_STATUS]: IN_PROGRESS,
  [PROP_RESPONSE]: [],
  [PROP_QUERY_PARAMS]: queryParams,
  [PROP_MODEL_ID]: null,
  [PROP_URL]: url,
})
